import React from 'react'
import * as styles from './styles'
import { Insight } from 'graphql/types'
import { Button } from '@material-ui/core'

type Props = {
  insight: Insight
}

const env = process.env.ENVIRONMENT === 'prod' || window.location.href.indexOf('prod') > -1 ? 'prod' : 'dev'

export const DetailsInfo = ({ insight }: Props) => {
  const Buttons = () => {
    if (insight.Error !== '') {
      return (
        <>
          <Button
            style={{ border: '1px solid #333', padding: '5px 15px', margin: '5px 0' }}
            href={`/inspectResult?insightID=${insight.InsightID}&userID=${insight.UserID}&extractView=1`}
            target="_blank"
            rel="noreferrer"
          >
            VIEW EXTRACT
          </Button>
        </>
      )
    }

    if (insight.Domain === 'energy-usage') {
      return (
        <Button
          style={{ border: '1px solid #333', padding: '5px 15px', margin: '5px 0' }}
          href={`https://demo.web.${env}.acaciamoney.com/energy/usage/${insight.UserID}/${insight.InsightID}`}
          target="_blank"
          rel="noreferrer"
        >
          VIEW INSIGHT
        </Button>
      )
    }

    return (
      <Button
        style={{ border: '1px solid #333', padding: '5px 15px', margin: '5px 0' }}
        href={`https://demo.web.${env}.acaciamoney.com/${insight.Domain}/openinsight/${insight.UserID}/${insight.InsightID}`}
        target="_blank"
        rel="noreferrer"
      >
        VIEW INSIGHT
      </Button>
    )
  }

  return (
    <div className={styles.info}>
      <div>
        <strong>{new Date(insight.GeneratedAt).toLocaleString()}</strong>
      </div>
      <div>{insight.Summary?.ProviderName}</div>
      <div>
        <strong>Insight ID: </strong>
        {insight.InsightID}
      </div>
      {insight.Error && (
        <div
          style={{
            backgroundColor: '#FFCCCB',
            border: '1px solid #333',
            borderRadius: '4px',
            padding: '5px',
            margin: '5px 0',
          }}
        >
          Error: {insight.Error}
        </div>
      )}
      {insight.Domain !== 'energy-usage' && (
        <div>
          <strong>Bill ID: </strong>
          {insight.BillId === '' ? 'NO BILL!' : insight.BillId}
        </div>
      )}
      {insight.Summary?.Source && (
        <div>
          <strong>Source: </strong>
          {insight.Summary.Source}
        </div>
      )}
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'space-around' }}>
        <Button
          style={{ border: '1px solid #333', padding: '5px 15px', margin: '5px 0' }}
          href={`/inspectResult?insightID=${insight.InsightID}&userID=${insight.UserID}`}
          target="_blank"
          rel="noreferrer"
        >
          SHOW RESULT
        </Button>
        <Buttons />
      </div>
    </div>
  )
}
